import { useState } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';
import { ConfirmDialogProps } from "../types/interfaces";

export const useConfirmDialog = () => {
    const [dialogOptions, setDialogOptions] = useState<ConfirmDialogProps | null>(null);

    const showConfirmDialog = (options: ConfirmDialogProps) => {
        setDialogOptions(options);
    };

    const handleClose = () => {
        setDialogOptions(null);
    };

    const ConfirmDialogComponent = dialogOptions ? (
        <ConfirmDialog {...dialogOptions} onCancel={handleClose} />
    ) : null;

    return { showConfirmDialog, ConfirmDialogComponent };
};
